jQuery(document).ready(function() {

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
        // code to be triggered when the confirmation page is loaded
        const form = jQuery('.form-data');
        const formTitle = form.data("title"); // Capture the form name before submission
        const formID = form.data("id");
        const franchise = form.data("franchise")

        const data = {
            'event': "formSubmission",
            'formID': formID,
            'formName': formTitle,
            'formFranchise': franchise
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    });

});